export default {
    USERS: 1,
    JOBS: 2,
    ACTIVITIES: 3,
    SKILLS: 4,
}